import React from 'react';

import TagLoader from './TagLoader';
import Stack from '../../Shared/UI/Stack/components/Stack';
import Divider from '../../Shared/UI/Divider/components/Divider';
import PageTitle from '../../Shared/UI/PageTitle/components/PageTitle';
import PageSectionTitle from '../../Shared/UI/PageSectionTitle/components/PageSectionTitle';
import TagInfo from './TagInfo';
import UpdateTagForm from './UpdateTagForm';
import AllowedTaggingRulesTable from './AllowedTaggingRulesTable';
import NewAllowedTaggingRuleForm from './NewAllowedTaggingRuleForm';
import DeniedTaggingRulesTable from './DeniedTaggingRulesTable';
import NewDeniedTaggingRuleForm from './NewDeniedTaggingRuleForm';
import AddToGlobalDenyListButton from './AddToGlobalDenyListButton';

import styles from './Tag.module.scss';

const Tag = ({ id }) => {
  return (
    <>
      <TagLoader id={id} />
      <div className={styles.pageLayout}>
        <Stack gap="lg">
          <PageTitle text={'Tag'} />
          <PageSectionTitle text={'Tag Info'} />
          <TagInfo />
          <Divider />
          <PageSectionTitle text={'Update Tag'} />
          <UpdateTagForm />
          <Divider />
          <PageSectionTitle text={'Allowed Tagging Rules'} />
          <AllowedTaggingRulesTable />
          <NewAllowedTaggingRuleForm />
          <Divider />
          <PageSectionTitle text={'Denied Tagging Rules'} />
          <DeniedTaggingRulesTable />
          <NewDeniedTaggingRuleForm />
          <Divider />
          <AddToGlobalDenyListButton />
        </Stack>
      </div>
    </>
  );
};

export default Tag;
